  $('.collection_add_to_cart').on('submit',function(e){
    e.preventDefault();
    let add=async ()=>{
    await $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: $(this).serialize(),
   }); 
   document.getElementById('cart-icon-bubble').click()
  } 
  add()
  
  })
